import { render, staticRenderFns } from "./ProcessGeneral.vue?vue&type=template&id=c893ea9a&scoped=true&"
import script from "./ProcessGeneral.vue?vue&type=script&lang=js&"
export * from "./ProcessGeneral.vue?vue&type=script&lang=js&"
import style0 from "./ProcessGeneral.vue?vue&type=style&index=0&id=c893ea9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c893ea9a",
  null
  
)

export default component.exports